// EN
export const availabilityPrices = {
  header: {
    title: "Disponibilità e tariffe",
  },
  common: {
    today: "Oggi",
    cancel: "Annulla",
    save: "Salva",
    saving: "Salvataggio…",
  },
  pricelabs: {
    title: "I prezzi sono gestiti da PriceLabs",
    text: "Le tariffe si aggiornano automaticamente e non possono essere modificate manualmente.",
  },
  topbar: {
    calendar: "Calendario",
    bulkEdit: "Modifica in blocco",
    configTitle: "Impostazioni calendario",
    syncSection: "Sincronizzazione",
    resyncOta: "Risincronizza con OTA",
    resyncOtaDesc: "Reinvia disponibilità e tariffe al canale.",
  },
  empty: {
    noHotelTitle: "Nessun alloggio di tipo hotel",
    noHotelDesc:
      "Crea un alloggio <strong>Hotel</strong> o <strong>Camping</strong> per iniziare a gestire disponibilità e tariffe.",
    goToListings: "Vai agli alloggi",
    noRoomsTitle: "{name} non ha camere",
    noRoomsDesc:
      "Questo alloggio non ha ancora camere registrate. Aggiungi unità dal dettaglio dell’alloggio per gestire disponibilità e tariffe.",
    configureListing: "Configura alloggio",
  },
  summary: {
    roomState: "Stato camere",
    roomsForSale: "Camere in vendita",
    netBooked: "Prenotato netto",
  },
  state: {
    available: "Disponibile",
    closed: "Chiuso",
    soldOut: "Esaurito",
    pastLabel: "N/D",
  },
  calendar: {
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of rooms / nights
    roomsCount: "{count} camera | {count} camere",
    minStayTooltip: "Soggiorno minimo: {count} notte | Soggiorno minimo: {count} notti",
  },
  offBadge: "SPENTA",
  offTooltip: "Vendita spenta: questa tariffa non è offerta su nessun canale. Le altre tariffe della camera restano in vendita.",
  rateMenu: {
    open: "Opzioni della tariffa",
    minStay: "Soggiorno minimo per date",
    priceLabsMinStay: "Questa tariffa è gestita da PriceLabs: il soggiorno minimo lo imposta lui.",
    stopSelling: "Ferma la vendita di questa tariffa",
    stopping: "Spegnimento vendita…",
    resuming: "Riattivazione vendita…",
    resumeSelling: "Riprendi la vendita di questa tariffa",
    derivedPriceHint: "Il prezzo di una tariffa derivata viene dalla principale",
    mainKeepsDerived: "Le sue tariffe derivate resteranno in vendita",
    mainNotYet: "Chiudere una tariffa principale non è ancora disponibile",
  },
  derived: {
    badge: "D",
    tooltip: "Tariffa derivata da: {parent}{rule}",
    rulePart: " · Regola: {rule}",
  },
  tooltips: {
    syncEnabled:
      "Ricalcola e reinvia disponibilità e soggiorno massimo all’OTA (previene l’overbooking).",
    syncDisabled: "Collega la struttura a un canale per abilitare la sincronizzazione.",
    toggleClosedOpen: "Alterna chiuso/aperto",
    managedByPricelabs: "Gestito da PriceLabs",
    clickToEdit: "Seleziona o clicca per modificare",
  },
  cellTitle: {
    pastDate: "Data passata",
    closed: "Chiuso (clicca per aprire)",
    detail:
      "{free} libere · offerte {tope} di {total} · {booked} prenotate — clicca per modificare il limite",
  },
  soldBadge: {
    confirmed: "{real} prenotazioni confermate",
    withOverbooking: "{real} confermate + {over} in overbooking",
  },
  bulkModal: {
    from: "Da",
    to: "A",
    rangeHint:
      "Puoi modificare qui l’intervallo per estenderlo o regolarlo. (La vista aggiornerà visivamente solo il mese corrente.)",
    room: "Camera",
    whatToEdit: "Cosa modificare",
    optAvail: "Disponibilità e chiusure",
    optRate: "Prezzi e soggiorno minimo",
    status: "Stato",
    open: "Apri",
    close: "Chiudi",
    cap: "limite",
    availHint:
      "Questo è il totale che offri; le prenotazioni vengono detratte automaticamente e si vendono solo le camere libere. Max {max} (operative, esclusa la manutenzione).",
    mainRate: "Tariffa principale",
    mainRateHint:
      "Scegli la tariffa principale da modificare; le sue tariffe derivate si adeguano automaticamente.",
    action: "Azione",
    price: "Prezzo",
    minStay: "Soggiorno minimo",
    minStayNights: "Soggiorno minimo (notti)",
    minStayHelp: "1 = nessuna restrizione (azzera)",
  },
  syncConfirm: {
    title: "Sincronizza con l’OTA",
    message:
      "Questo ricalcolerà e reinvierà all’OTA la disponibilità e il soggiorno massimo di questo calendario.",
    confirm: "Sì, sincronizza",
  },
  progress: {
    processing: "Elaborazione…",
    syncing: "Sincronizzazione del calendario con l’OTA…",
    updatingAvail: "Aggiornamento della disponibilità…",
    updatingRate: "Aggiornamento della tariffa…",
    applying: "Applicazione delle modifiche…",
    applyingBulk: "Applicazione della modifica in blocco…",
    applyingIn: "Applicazione a {name}…",
  },
  toasts: {
    noPropertyToSync: "Non c’è nessuna struttura da sincronizzare.",
    syncOk: "Calendario ricalcolato e sincronizzato con l’OTA.",
    syncErr: "Impossibile sincronizzare il calendario con l’OTA.",
    loadErr: "Impossibile caricare le informazioni dell’hotel.",
    maxAvailClosedBlocked:
      "Disponibilità massima: {capacity} (ci sono camere chiuse, bloccate o in manutenzione).",
    availUpdated: "Disponibilità aggiornata",
    availUpdateErr: "Impossibile aggiornare la disponibilità",
    freeSuffix: " (libere: {free})",
    rateUpdated: "Tariffa aggiornata",
    rateUpdateErr: "Impossibile aggiornare la tariffa",
    maxAvailMaintenance:
      "Disponibilità massima: {capacity} (ci sono camere in manutenzione o non operative).",
    noDatesModifiedBooked: "Nessuna data modificata: {count} con prenotazioni.",
    appliedFreeDates:
      "Applicato alle date libere. {count} data/e con prenotazioni non sono state modificate.",
    changesApplied: "Modifiche applicate con successo",
    savedNotSyncedYet: "Salvato qui, ma non è ancora arrivato ai canali di vendita. Verrà ritentato da solo tra qualche minuto.",
    cannotEditDerivedPricelabs:
      "Non puoi modificare una tariffa derivata o gestita da PriceLabs.",
    minStayNumberGte1: "Il soggiorno minimo deve essere un numero >= 1.",
    invalidAction: "Azione non valida.",
    applyErr: "Impossibile applicare le modifiche",
    noRoomsToEdit: "Non ci sono camere da modificare.",
    selectAtLeastOneRoom: "Seleziona almeno una camera.",
    chooseAction: "Scegli un’azione.",
    selectDateRange: "Seleziona un intervallo di date.",
    enterValidPrice: "Inserisci un prezzo valido.",
    minStayGte1: "Il soggiorno minimo deve essere >= 1.",
    appliedWithErrors: "Applicato a {ok} camera/e. {failed} con errore",
    noDatesModifiedCapacity:
      "Nessuna data modificata: in {count} giorno/i non era consentito quel numero di camere.",
    bulkAppliedClamped:
      "Modifica in blocco applicata a {ok} camera/e. In {clamped} data/e è stata adeguata al numero di camere in servizio.",
    bulkApplied: "Modifica in blocco applicata a {ok} camera/e.",
    bulkApplyErr: "Impossibile applicare la modifica in blocco.",
    applyChangesErr: "Impossibile applicare le modifiche.",
  },
  // Decorative (aria-hidden) empty-state content
  ghost: {
    month: "MAGGIO 2026",
    day1: "Lun 1",
    day2: "Mar 2",
    day3: "Mer 3",
    day4: "Gio 4",
    day5: "Ven 5",
    day6: "Sab 6",
    day7: "Dom 7",
    day8: "Lun 8",
    day9: "Mar 9",
    day10: "Mer 10",
    day11: "Gio 11",
    day12: "Ven 12",
    unit1: "Suite Deluxe",
    unit1Rooms: "(2 camere)",
    unit2: "Camera Standard",
    unit2Rooms: "(3 camere)",
    baseRate: "Tariffa base",
    nonRefundable: "Non rimborsabile",
  },
};
